import PropTypes from 'prop-types';

import { SECONDARY_PRODUCT_TYPES } from '@hero/constants';
import { ProductDetailModal, SecondaryProductDetailModal } from '@hero/organisms';

const ProductListItemDetail = props => {
  const isSecondary = SECONDARY_PRODUCT_TYPES.includes(props?.product?.meta?.productType);

  if (isSecondary) {
    return (
      <SecondaryProductDetailModal {...props} secondaryType={props?.product?.meta?.productType} />
    );
  }

  return <ProductDetailModal {...props} />;
};

ProductListItemDetail.propTypes = {
  product: PropTypes.shape({
    meta: PropTypes.shape({
      productType: PropTypes.string
    })
  }).isRequired
};

export { ProductListItemDetail };
